var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visibility-select"},_vm._l((_vm.options),function(opt){return _c('button',{key:opt.value,staticClass:"v-btn",class:{ active: _vm.value === opt.value },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('input', opt.value)}}},[_c('span',[_vm._v(_vm._s(opt.icon))]),_vm._v(" "+_vm._s(opt.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }